import React, { useState } from "react";

import allskillsdata from "../data/skillsdata";
import SkillsCard from "./SkillsCard";

const Skills = () => {
	// eslint-disable-next-line no-unused-vars
	const [allskill, setAllskills] = useState(allskillsdata);
	const [skills, setSkills] = useState(
		allskillsdata.filter((data) => data.category === "WEB")
	);

	const handlefilter = (category) => {
		const filter = allskill.filter((data) => data.category === category);

		setSkills(filter);
	};

	return (
		<div className="bg-dark ">
			<h3 className="text-center text-white  ">My Skills</h3>
			<div className="d-flex justify-content-center">
				<button
					className="btn btn-secondary ml-2 "
					onClick={() => handlefilter("WEB")}
				>
          Web
				</button>
				<button
					className="btn btn-secondary ml-2"
					onClick={() => handlefilter("OTHERS")}
				>
          Others
				</button>
				<button
					className="btn btn-secondary ml-2"
					onClick={() => handlefilter("PROGRAMMING")}
				>
          Programming
				</button>
				<button
					className="btn btn-secondary ml-2"
					onClick={() => handlefilter("Tools")}
				>
          Tools
				</button>
			</div>
			<div className="row">
        
				{skills.map((skillsdata) => (
					<div className="col-md-6" key={skillsdata.name}>
						<SkillsCard skillsdata={skillsdata}  />
					</div>
				))}
      
			</div>
		</div>
	);
};

export default Skills;
